import Fingerprint2 from 'fingerprintjs2';
import { useRequest } from '@local-composable/request';

export let ident_uid = localStorage.getItem('USER_IDENT') || null;

function setFingerprint() {
  return new Promise((resolve) => {
    Fingerprint2.get(
      {
        excludes: {
          language: true,
          deviceMemory: true,
          sessionStorage: true,
          localStorage: true,
          indexedDb: true,
          addBehavior: true,
          openDatabase: true,
          doNotTrack: true,
          plugins: true,
          canvas: true,
          webglVendorAndRenderer: true,
          adBlock: true,
          hasLiedLanguages: true,
          hasLiedResolution: true,
          hasLiedOs: true,
          hasLiedBrowser: true,
          touchSupport: true,
          audio: false,
          enumerateDevices: true,
          hardwareConcurrency: true,
        },
        extraComponents: [
          {
            key: 'ip',
            getData: function (done) {
              useRequest({
                url: '/v1/common/get_ip',
              })
                .get()
                .then(({ data }) => {
                  const ip = data?.value?.ip_v4;
                  done(ip);
                })
                .catch(() => {
                  done('');
                });
            },
          },
        ],
      },
      (components) => {
        const values = components.map((component) => component.value);
        const finger = Fingerprint2.x64hash128(values.join(''), 31);
        resolve(finger);
      },
    );
  });
}

export function createFingerprint(callback = () => {}) {
  if (ident_uid) {
    callback();
    return;
  }
  setFingerprint().then((finger) => {
    ident_uid = finger;
    callback();
  });
}

if (window.requestIdleCallback) {
  requestIdleCallback(() => {
    createFingerprint();
  });
}

export const point = async ({ event, product_id }) => {
  createFingerprint(() => {
    useRequest({
      url: `/v1/point/event.${event}`,
      data: {
        event,
        request_uri: location.href,
        ident_uid,
        product_id,
      },
    }).post();
  });
};

export const getIp = () => {
  return useRequest({
    url: '/v1/common/get_ip',
  }).get();
};
